import { Monitor } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useDeviceType } from "@/hooks/use-device-type";

export function MobileViewSwitcher() {
  const { toggleDesktopView, isDesktopView } = useDeviceType();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleDesktopView}
      className="touch-target"
      title={isDesktopView ? "Mobile-Ansicht" : "Desktop-Ansicht"}
    >
      <Monitor className="w-5 h-5" />
    </Button>
  );
}
